import React, { Component, Fragment } from 'react';

import { Link } from 'react-router-dom';
import SwipeableViews from 'react-swipeable-views';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';

import ViewIndicator from './ViewIndicator';
import Card from '../../artzu-ui/src/Card';
import Modal from '../../artzu-ui/src/Modal';
import Button from '../../artzu-ui/src/Button';
import Icon1 from '../../images/Welcome/Icon1.png';
import Icon2 from '../../images/Welcome/Icon2.png';
import Icon3 from '../../images/Welcome/Icon3.png';
import Icon4 from '../../images/Welcome/Icon4.png';

const cardDetails = [
  {
    title: '#1 The Basics',
    icon: Icon1,
    content: 'Learn how Autzu works'
  },
  {
    title: '#2 Account',
    icon: Icon2,
    content: 'Provide all important information'
  },
  {
    title: '#3 Booking',
    icon: Icon3,
    content: 'Planning and booking ahead'
  },
  {
    title: '#4 Rules',
    icon: Icon4,
    content: 'Things to know for the best experience'
  }
];

const cardDetailsNyc = [
  {
    title: '#1 The Basics',
    icon: Icon1,
    content: 'Learn how Autzu works'
  },
  {
    title: '#2 Booking',
    icon: Icon3,
    content: 'Planning and booking ahead'
  },
  {
    title: '#3 Rules',
    icon: Icon4,
    content: 'Things to know for the best experience'
  }
]

const styles = {
  root: {
    padding: '0 22.5vw',
    width: '100vw'
  },
  slide: {
    width: '50vw',
    margin: '0 2.5vw'
  },
  slide1: {
    background: '#fff',
    color: '#414141'
  },
  slide2: {
    color: '#414141',
    opacity: 0.4
  },
  slide3: {
    background: '#6AC0FF'
  }
};

class IntroWidgetHandler extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cardIndex: 0,
      introClicked: 0,
      modal: false
    };
  }

  handleIndexChange = cardIndex => {
    this.setState({ cardIndex });
  };

  handleModalOpen = () => {
    this.setState({ modal: true });
  };

  handleModalClose = () => {
    this.setState({ modal: false });
  };

  handleModalDone = () => {
    const { handleClickClose } = this.props;
    handleClickClose();
    this.setState({ modal: false });
  };

  render() {
    const { cardIndex, modal } = this.state;
    const { mobile, showCloseIcon, handleClickClose, city } = this.props;
    var cardInfo = null
    if (city === 'new_york'){
      cardInfo = cardDetailsNyc
    } else {
      cardInfo = cardDetails
    }
    return (
      <Fragment>
        {mobile ? ( // show swipeable cards on mobile
          <div className="intro-widget">
            <div className="intro-widget__title-container">
              <div className="intro-widget__title">
                Welcome to Autzu! Please go through the below information
                to learn how to get started with Autzu.
              </div>
              <div className="intro-widget__close">
                {showCloseIcon ? (
                  <a onClick={this.handleModalOpen}>
                    <FontAwesomeIcon
                      icon={faTimes}
                      style={{ color: 'white' }}
                      size="s"
                    />
                  </a>
                ) : null}
              </div>
            </div>
            <Fragment>
              <SwipeableViews
                className="carousel"
                style={styles.root}
                slideStyle={styles.slide}
                onChangeIndex={this.handleIndexChange}
                index={0}>
                {cardInfo.map((card, index) => {
                  return (
                    <Card
                      className="book-card"
                      key={index}
                      width="50vw"
                      style={Object.assign(
                        {},
                        cardIndex === index ? styles.slide1 : styles.slide2
                      )}>
                      <div className="intro-card__title">{card.title}</div>
                      <img
                        className="intro-card__icon"
                        src={card.icon}
                        alt=""
                      />
                      <div className="intro-card__content">
                        {card.content}
                      </div>
                      <Link to={`/intro/${index + 1}`}>
                        <div className="intro-card__link">
                          <a>Click Here</a>
                        </div>
                      </Link>
                    </Card>
                  );
                })}
              </SwipeableViews>
              <ViewIndicator
                dots={cardInfo.length}
                index={cardIndex}
                active="#FFFFFF"
                inactive="#DEDEDE"
              />
            </Fragment>
          </div>
        ) : (
          <div className="intro-widget">
            <div className="intro-widget__title-container">
              <div className="intro-widget__title">
                Welcome to Autzu! Please go through the below information
                to learn how to get started with Autzu.
              </div>
              <div className="intro-widget__close">
                {showCloseIcon ? (
                  <a onClick={this.handleModalOpen}>
                    <FontAwesomeIcon
                      icon={faTimes}
                      style={{ color: 'white' }}
                      size="2x"
                    />
                  </a>
                ) : null}
              </div>
            </div>
            <div className="desk-card-container">
              {cardInfo.map((card, index) => {
                return (
                  <Card
                    className="book-card book-card-desk"
                    key={index}
                    width="180px">
                    <div className="intro-card__title">{card.title}</div>
                    <img
                      className="intro-card__icon"
                      src={card.icon}
                      alt=""
                    />
                    <div className="intro-card__content">
                      {card.content}
                    </div>
                    <Link to={`/intro/${index + 1}`}>
                      <div className="intro-card__link">
                        <a>Click Here</a>
                      </div>
                    </Link>
                  </Card>
                );
              })}
            </div>
          </div>
        )}
        <Modal open={modal} width="40vw">
          <div className="intro-widget__modal">
            <div className="intro-widget__modal__message">
              If you have read all the cards, press <b>Okay</b> below to
              hide this section.
            </div>
            <div className="intro-widget__modal__button-group">
              <Button
                label="Cancel"
                color="#414141"
                onClick={this.handleModalClose}
              />
              <Button
                label="Okay"
                color="#128DFF"
                onClick={this.handleModalDone}
              />
            </div>
          </div>
        </Modal>
      </Fragment>
    );
  }
}

export default IntroWidgetHandler;



// WEBPACK FOOTER //
// ./src/components/NewDash/IntroWidgetHandler.js